// @/utils/pdf-download.js
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export async function downloadPDF(module, id) {
  const toast = useToast();
  
  try {
    const response = await axios.get(`/${module}/${id}/pdf`, {
      responseType: 'blob'
    });

    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileURL;
    // Optional: use a filename based on quotation number, id, or timestamp
    link.download = `${module}_${id}.pdf`;
    document.body.appendChild(link);
    link.click();
    // Remove the link and revoke the object URL
    document.body.removeChild(link);
    URL.revokeObjectURL(fileURL);
  } catch (error) {
    toast.error("Failed to download PDF");
    console.error(error);
  }
}
